import script from "./TextareaField.vue?vue&type=script&setup=true&lang=ts"
export * from "./TextareaField.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__